// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ChevronLeft: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 28 28"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M14 28C6.28 28 0 21.72 0 14S6.28 0 14 0s14 6.28 14 14-6.28 14-14 14zm0-26.5C7.11 1.5 1.5 7.11 1.5 14S7.11 26.5 14 26.5 26.5 20.89 26.5 14 20.89 1.5 14 1.5z" />
            <path
                fill="#292929"
                fillRule="evenodd"
                d="M17.38 19.43l-5.49-5.37 5.49-5.36-1.64-1.64-7.12 7 7.12 7z"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(ChevronLeft);
